import React from 'react';
import { useStyles } from './appStyle';
import {
  AppShell,
  NavigatorItem,
  NavigatorLinkMenu,
} from '@forgeglobal/design-framework';
import Logo from '@tcs/client-portal-common/components/organisms/ApplicationLayout/Logo';
import HeaderRail from '@tcs/client-portal-common/components/molecules/HeaderRail';
import NavFooter from './NavFooter';
import NavHeader from './NavHeader';
import CollapsedLogo from './CollapsedLogo';
import useSession from '@tcs/client-portal-common/hooks/useSession';
import MainDisclaimer from '@tcs/common/components/atoms/footer/MainDisclaimer';
const APP_BASE_URL = 'accounts';

export interface AppLayoutProps {
  children: React.ReactNode;
  navigatorLinkMenu?: NavigatorLinkMenu;
  navigatorItems: NavigatorItem[];
  searchBar?: React.ReactNode;
}

const AppLayout = ({
  navigatorLinkMenu,
  navigatorItems,
  children,
  searchBar,
  ...rest
}: AppLayoutProps) => {
  const classes = useStyles();
  const { claims, profile } = useSession();

  if (!profile && !claims) {
    // @TODO: profile not found
    return null;
  }

  return (
    <AppShell
      logoUrl={APP_BASE_URL}
      isHeaderShown
      logoComponent={(navbarOpen, isMobile) => (
        <Logo navbarOpen={navbarOpen} isMobile={isMobile} />
      )}
      collapsedLogo={<CollapsedLogo />}
      searchBar={searchBar}
      navigatorDefaultOpenOnDesktop
      headerItems={<HeaderRail />}
      navigatorHeader={(navOpen) => (
        <NavHeader
          firstName={
            profile?.personalInfo?.firstName || claims.given_name || ''
          }
          isVisible={navOpen}
        />
      )}
      navigatorLinkMenu={navigatorLinkMenu}
      navigatorItems={navigatorItems}
      navigatorFooter={(navOpen, isMobile) => (
        <NavFooter isVisible={navOpen} isMobile={isMobile} />
      )}
      {...rest}>
      <div className={classes.appContentWrapper}>
        {children}
        <MainDisclaimer />
      </div>
    </AppShell>
  );
};

export default AppLayout;
